export default __webpack_public_path__ + "static/media/004-B-autres.767099fd.svg";